import type { IconData } from '@stacksjs/iconify-core'

export const memory: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M192 320h128V192H192Zm32-96h64v64h-64Z\"/><path fill=\"currentColor\" d=\"M32 288v32h72v88h88v72h32v-72h64v72h32v-72h88v-88h72v-32h-72v-64h72v-32h-72v-88h-88V32h-32v72h-64V32h-32v72h-88v88H32v32h72v64Zm104-152h240v240H136Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default memory
